import { Pipe, PipeTransform } from '@angular/core';

const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

@Pipe({
  name: 'lettering',
})
export class LetteringPipe implements PipeTransform {
  public transform(value: number): string {
    return letters[value % letters.length];
  }
}
